import { MapMarker as marker } from '@hqo/react-components-library/dist/icons';
import styled from 'styled-components';

export const MapMarker = styled(marker)`
  color: ${({ theme }): string => theme.colors.fontColor};
`;
